import React, { useRef, useState } from "react";
import fetchURLForm from "../../../functions/fetchURLForm";
import { fetchUrl } from "../../../functions/fetchUrl";

const EditBillablePosted = ({ data, showEditingStoreBox }) => {
  const servicename = useRef("");
  const postednumber = useRef("");
  const percentage = useRef("");
  const hour = useRef("");

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  // to set imageWidget state as an image

  const handleSave = async (event) => {
    event.preventDefault();
    // const body = new FormData();

    // body.append("servicename", servicename.current.value);
    // body.append("postednumber", postednumber.current.value);
    // body.append("percentage", percentage.current.value);
    // body.append("hour", hour.current.value);

     const bodySend = {
      servicename: servicename.current.value,
      postednumber: postednumber.current.value,
      percentage: percentage.current.value,
      hour: hour.current.value,
    };


    const response = await fetchUrl({
      apiName: `services/billableposted/${data.id}`,
      method: "PUT",
      reqBody: bodySend
    });
    if (response.success) {
      setSuccess(true);
      setTimeout(() => {
        showEditingStoreBox();
      }, 300);
    } else {
      setError(true);
      console.log(response);
    }
  };
  const hideAlert = () => {
    setSuccess(false);
    setError(false);
  };
  return (
    <div
      id="addNoteModal"
      className="modal"
      style={{
        zIndex: "99999",
      }}
    >
      <div className="modal-content">
        <div className="modal-header">
          <h2>
            Edit Service <span className="text-warning">{data.name}</span>{" "}
          </h2>
        </div>
        <div>
          {success && (
            <div className="alert alert-success" role="alert">
              Edited Successfully...
            </div>
          )}
          {error && (
            <div className="alert alert-anger" role="alert">
              Edited Failed Try Again...
            </div>
          )}
        </div>
        <form
          className="w-100 p-5"
          encType="multipart/form-data"
          onSubmit={handleSave}
        >
          <div className="mt-2">
            <label htmlFor="servicename">Service Name</label>
            <input
              ref={servicename}
              type="text"
              id="servicename"
              placeholder="Name Of Store"
              className="form-control"
              required
              defaultValue={data.servicename}
              onChange={hideAlert}
            />
          </div>
          <div className="mt-2">
            <label htmlFor="postednumber">Posted</label>
            <input
              ref={postednumber}
              type="text"
              id="postednumber"
              placeholder="postednumber"
              className="form-control"
              required
              defaultValue={data.postednumber}
              onChange={hideAlert}
            />
          </div>
          <div className="mt-2">
            <label htmlFor="percentage">Percentage %</label>
            <input
              ref={percentage}
              type="text"
              id="percentage"
              placeholder="percentage"
              className="form-control"
              required
              defaultValue={data.percentage}
              onChange={hideAlert}
            />
          </div>

          <div className="mt-2">
            <label htmlFor="hour">Hour</label>
            <input
              ref={hour}
              type="text"
              id="hour"
              placeholder="hour"
              className="form-control"
              required
              defaultValue={data.hour}
              onChange={hideAlert}
            />
          </div>

          <div className="modal-footer">
            <button type="submit" className="btn btn-primary">
              Update
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={showEditingStoreBox}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditBillablePosted;
